import getRouters from "@/components/common/getRouters";
import { getStorageInfo } from "@/components/common/getStorageInfo";
import { routers } from "@/components/Router/router.config";
import { useStore } from "@/stores";
import UnAuthentStore from "@/stores/UnAuthentStore";
import { getUrlVal } from "@/utils/utils";
import { observer } from "mobx-react";
import { FC } from "react";
import { Route, Switch } from "react-router-dom";
import LayoutPage from "./LayoutPage";
import UnAuthent from "./UnAuthent";

const Page: FC = () => {
    let code = getUrlVal("code")
    const xc = getStorageInfo('xc');
    //判断是否是带code的页面刷新
    let Judge = !!code && code !== xc;
    const local_userId = String(getStorageInfo('userId'));
    const session_userId = String(sessionStorage.getItem("userId"));
    const isAuth = !!session_userId && local_userId === session_userId;
    const unAuthentStore = useStore('UnAuthentStore') as typeof UnAuthentStore;
    return (!(unAuthentStore.isLogin || isAuth) || !!Judge) ? <UnAuthent />:(
        <>
            <Switch>
                {getRouters(routers)}
                <Route path="/" render={(props: any) => <LayoutPage />} />
            </Switch>

        </>
    )
}
export default observer(Page);